import { usePlanIsHiddenHotelQuestions as useIsHiddenHotelQuestions } from "@/components/features/items/edit/plan/_shared/ui/components/pre-questions/is-hidden-hotel-questions/hooks";

import { useProductPlanFormModelContext } from "../../../../../context";

export const usePlanIsHiddenHotelQuestions = () => {
	const { viewModel, onSetViewModel, queryData } = useProductPlanFormModelContext();
	const { isHiddenHotelQuestions } = viewModel;
	const { questions } = queryData.hotelPolicy;

	return useIsHiddenHotelQuestions({
		questions,
		isHiddenHotelQuestions,
		onSetViewModel,
	});
};
